import { defineStore } from 'pinia'

export const useDialogStore = defineStore({
  id: 'useDialogStore',
  state: () => ({ 
    title: "",
    text: "",
    icon: "",
    enabled: false,
    fn: null
  }),
  actions: {
    error(body, fn){
      this.status = "alert";
      this.show("錯誤", body, fn);
    },
    info(body, fn) {
      this.status = "info";
      this.show("通知", body, fn);
    },
    show(title, body, fn){
      this.title = title;
      if (body instanceof String || typeof body === "string")
        this.text = body;
      else if (body.data instanceof String || typeof body.data === "string")
        this.text = body.data;
      else
        this.text = body?.data?.statusMessage || body?.statusMessage|| "";
      this.enabled = true;
      this.fn = fn;
    },
    async close(){
      this.title = "";
      this.text = "";
      this.enabled = false;
      if (this.fn){
        await this.fn();
        this.fn = null;
      }
    }
  }
})
